import React from "react";
import "../../css/toastView.css";
import Heading from "../../components/Heading";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";

const icon1 = "https://winpeforum.com/assets/elements/VandanaPai.jpg";
const icon2 = "https://winpeforum.com/assets/elements/KarnikaVallabh.jpg";
let duration = 400;
 

const I1 = "https://www.winpeforum.com/assets/wob/4dec2025/1.png";
const I2 = "https://www.winpeforum.com/assets/wob/4dec2025/2.png";
const I3 = "https://www.winpeforum.com/assets/wob/4dec2025/3.png";
const I4 = "https://www.winpeforum.com/assets/wob/4dec2025/4.png";
const I5 = "https://www.winpeforum.com/assets/wob/4dec2025/5.png";
const I6 = "https://www.winpeforum.com/assets/wob/4dec2025/6.png";
const I7 = "https://www.winpeforum.com/assets/wob/4dec2025/7.png";
const I8 = "https://www.winpeforum.com/assets/wob/4dec2025/8.png";
const I9 = "https://www.winpeforum.com/assets/wob/4dec2025/9.png";
const I10 = "https://www.winpeforum.com/assets/wob/4dec2025/10.png";
const I11 = "https://www.winpeforum.com/assets/wob/4dec2025/11.png";
const I12 = "https://www.winpeforum.com/assets/wob/4dec2025/12.png";
 

 
 

const II1 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/1.png";
const II2 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/2.png";
const II3 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/3.png";
const II4 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/4.png";
const II5 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/5.png";
const II6 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/6.png";
const II7 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/7.png";
const II8 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/8.png";
const II9 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/9.png";
const II10 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/10.png";
const II11 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/11.png";
const II12 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/12.png"; 
 

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class SheShines extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
     
    this.Speaker1 = [
        {
          imgUrl: icon2,
          desc: ` `,
          name: "Karnika Vallabh",
          post: `<div>Legal Counsel<br/>Bharucha & Partners




          </div>`,
        },
          
              {
          imgUrl: icon1,
          desc: `<div>
 
 
          </div>`,
          name: "Vandana Pai",
          post: `<div>Senior Partner<br/>Bharucha & Partner


          </div>`,
        },
      
      
    ];

    this.Speaker2 = [
       
      
      {
        imgUrl: icon2,
        desc: `Alka Goel is the Founder of Alkemi Growth Capital LLP, an early stage healthcare and consumer wellness fund. She has led investment in multiple sub-sectors over the last 6 years. Prior to that, Alka was a Partner in McKinsey & Co., New York office, where she primarily served clients in the life science and private equity industry.
<br/><br/>
At McKinsey, she served more than 350 Clients across all major geographies. She completed her business school from Indian Institute of Management, Ahmedabad in 2000 and Bachelor of Economics from Lady Shri Ram College, Delhi University.


         `,
        name: "Alka Goel",
        post: `<div>Founding Partner<br/> Alkemi Growth Capital
        </div>`,
      },

      
    ];
    this.CollegiumsImages = [
      { id:23, ImgSrc: I1, ImgSrc1: II1,},   
      
        { id:35, ImgSrc: I2, ImgSrc1: II2,},   

        { id:22, ImgSrc: I3, ImgSrc1: II3,},   
        { id:19, ImgSrc: I4, ImgSrc1: II4,},  
        { id:35, ImgSrc: I5, ImgSrc1: II5,},   
        { id:34, ImgSrc: I6, ImgSrc1: II6,},  
        { id:23, ImgSrc: I7, ImgSrc1: II7,},   
      
        { id:35, ImgSrc: I8, ImgSrc1: II8,},   

        { id:22, ImgSrc: I9, ImgSrc1: II9,},   
        { id:19, ImgSrc: I10, ImgSrc1: II10,},  
        { id:35, ImgSrc: I11, ImgSrc1: II11,},   
        { id:34, ImgSrc: I12, ImgSrc1: II12,},  
    
    ];
  
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
    let settings = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;
    return (
      <ContentPage>
         <Meta
          title="Women on Boards"
          image={"https://winpeforum.com/assets/wob/banner.jpg"}
          description="Winpe- Women on Boards (WoB) supports organisations in building stronger, future-ready boards through curated leadership networks and engagement with board-ready talent. As part of this initiative, Self-Led Sessions bring women leaders together to exchange perspectives on real-world governance challenges and emerging boardroom priorities."
          location={location}
        />
        <div className="section__content" style={defaultStyle}>
          <div className="toastshine_wrapper">
            <div className="back_event">
              <Link to="/events/">
                <i className="fa fa-arrow-left">Back to Events</i>
              </Link>
            </div>
            <div className="toastshine_section">
              <div className="m_heading">        Winpe’s Women on Boards<br/>
                         Session: Shareholder Misalignment- Who does the Board Actually Serve


  </div>
              <div className="r_btm"></div>
               
 
              <div className="date_heading">
                <div className="date_heading">
                 <span> 
      May 29th, 2026 (04:00 - 05:00 PM IST)<br/>
   Format- Virtual (Zoom)
</span>
                </div>
              </div>
              <br/>     
              
              <div className="top_text" style={{textAlign:'justify'}}>
        Winpe- Women on Boards (WoB) supports organisations in building stronger, future-ready boards through curated leadership networks and engagement with board-ready talent. As part of this initiative, Self-Led Sessions bring women leaders together to exchange perspectives on real-world governance challenges and emerging boardroom priorities.<br/><br/>
Inspired by the recent governance issues associated with Tata Sons and drawing on publicly available information, this session explored how boards navigate multi-stakeholder dynamics and conflicting shareholder priorities while maintaining organisational stability and strategic momentum. Participants examined the board’s role in managing impasses around leadership continuity and long-term strategic decisions, balancing promoter influence with management independence, sustaining market confidence during transitions, and ensuring continuity through effective contingency and succession planning.<br/><br/>
The peer-led format enabled a candid and substantive exchange among senior women leaders, whose diverse board and leadership experiences enriched the conversation with practical insights and real-world governance perspectives. <br/><br/>
Feedback was exceptionally positive, with participants describing the discussion as engaging, insightful, and highly relevant to their board and leadership responsibilities. The quality of peer interaction emerged as a defining strength, with many valuing the opportunity for thoughtful dialogue and governance insights that extended beyond the case itself and offered practical relevance for board-level decision-making.<br/><br/>
<i>Note: The session was conducted under Chatham House Rules and was not recorded.</i>

   <br/><br/>

 <div className="row"> 
    <div className="col-md-2">&nbsp;</div>
    <div className="col-md-8">
   <img src="https://winpeforum.com/assets/elements/wob29may.png" style={{width:'100%'}}/> 
    </div>
 </div>


 

              </div>
              
             
            
  <br/> 
   
<div class="container">
<br/>
 
 
 </div>
       
          <br/><br/>
     
            </div>
            <TeamModal
              show={isShow}
              onHide={this.togglePopUp}
              activeItem={this.state.activeItem}
            />
          </div>
        </div>
      </ContentPage>
    );
  }
}

SheShines.propTypes = {
  location: PropTypes.object,
};

export default SheShines;



// WEBPACK FOOTER //
// ./src/pages/WOBShareholderMisalignment/index.js